import { render, staticRenderFns } from "./GraphPhotoAvatar.vue?vue&type=template&id=6c52cc8f"
import script from "./GraphPhotoAvatar.vue?vue&type=script&lang=js"
export * from "./GraphPhotoAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports